export type ConfettiAppState = {
  showConfetti: boolean;
};

export const INITIAL_CONFETTI_APP_STATE: ConfettiAppState = {
  showConfetti: false,
};
